export function queuedByPositionColumn({ t }) {
  const currentYear = new Date().getFullYear();
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      maxWidth: 60,
      filterable: false,
      style: { textAlign: 'center' }
    },
    {
      Header: t('monitoring_columnLocation'),
      accessor: 'region',
      style: { textAlign: 'center' },
      filterable: false,
      minWidth: 300,
      Cell: () => t('region')
    },
    {
      Header: t('territorial_affiliation'),
      accessor: 'territorial_affiliation',
      style: { textAlign: 'center' },
      minWidth: 250,
      filterable: false,
      Cell: ({ original: { territorial_affiliation } }) => `${t(territorial_affiliation)}`
    },
    {
      Header: t('total'),
      accessor: 'total',
      style: { textAlign: 'center' },
      filterable: false
    },
    {
      Header: `${currentYear - 1} ${t('age_suffix')}`,
      accessor: 'age_1',
      style: { textAlign: 'center' },
      filterable: false
    },
    {
      Header: `${currentYear - 2} ${t('age_suffix')}`,
      accessor: 'age_2',
      style: { textAlign: 'center' },
      filterable: false
    },
    {
      Header: `${currentYear - 3} ${t('age_suffix')}`,
      accessor: 'age_3',
      style: { textAlign: 'center' },
      filterable: false
    },
    {
      Header: `${currentYear - 4} ${t('age_suffix')}`,
      accessor: 'age_4',
      style: { textAlign: 'center' },
      filterable: false
    },
    {
      Header: `${currentYear - 5} ${t('age_suffix')}`,
      accessor: 'age_5',
      style: { textAlign: 'center' },
      filterable: false
    },
    {
      Header: `${currentYear - 6} ${t('age_suffix')}`,
      accessor: 'age_6',
      style: { textAlign: 'center' },
      filterable: false
    }
  ];
}
